/**
 * 毛坯房精装-图片控制
 * @returns
 */
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Button,
  ModalFooter,
  SimpleGrid,
  useDisclosure,
} from "@chakra-ui/react";
import { Content } from "@/types/content";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { contentRemove, selectContentsAll } from "@/reducer/contentSlice";
import { useCallback, useEffect, useState } from "react";
import HistoryModalItem from "../design/historyModal/historyModalItem";
import SmrHistoryModalItem from "./smroomHistoryModalItem";
import SmrDeleteModal from "./deletemodal";
import Client4 from "@/services/api/client4";
import { selectCurrentImage, setCurrentImage } from "@/reducer/designslice";
import JSZip from 'jszip';
import FileSaver from 'file-saver';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onDelete: (contentId: string) => void;
};

const SmrHistoryModal = (props: Props) => {
  const { isOpen, onClose , onDelete } = props;
  const dispatch = useAppDispatch();
  const contents = useAppSelector(selectContentsAll);
  const currentImage = useAppSelector(selectCurrentImage);
  
  const [images, setImages] = useState<Content[]>([]);
  const [currentContentId, setCurrentContentId] = useState("");
  const deleteControl = useDisclosure();

  const checkedImages = images.filter((item) => item.isChecked === true);

  const handlesImagesData = () => {
    const newImage = contents.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setImages(newImage);
  };
  useEffect(() => {
    handlesImagesData();
  }, [contents]);

  const handleCheckBox = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    let newImages = [...images];
    newImages.map((item) => {
      if (item.id === id) {
        item.isChecked = e.target.checked;
        return;
      }
    });
    setImages(newImages);
  };

  const handleBatchDelete = () => {
    if(checkedImages.length>0){
      deleteControl.onOpen();
    }
    
  };

  const handleDeleteChecked = () => {
    const  hasCurrentImage = checkedImages.filter((item) => item.id === currentImage.id);
    if(hasCurrentImage){
      dispatch(setCurrentImage({} as Content ));
    }

    checkedImages.map((item) => {
      dispatch(contentRemove(item.id));
      Client4.deleteContent(item.id);
    })
    deleteControl.onClose();
    onClose();
  };

  const OnDownload = () => {
    if (checkedImages.length<0 || checkedImages.length==0) {
      return;
    }
    let blogTitle = "打包图片";
    let zip = new JSZip();
    let imgs = zip.folder(blogTitle);
    let baseList:string[] = [];

    checkedImages.map(async(item, index) => {
      let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          if (!context) return;
          context.drawImage(image, 0, 0, image.width, image.height);
          let url = canvas.toDataURL(); // 得到图片的base64编码数据
          canvas.toDataURL("image/png");
          baseList.push(url.substring(22)); // 去掉base64编码前的     data:image/png;base64,
          if (baseList.length === checkedImages.length && baseList.length > 0) {
            for (let k = 0; k < baseList.length; k++) {
              imgs!.file(`图片${Number(k) + 1}.png`, baseList[k], { base64: true });
            }
            zip.generateAsync({ type: "blob" }).then(function (content) {
              // see FileSaver.js
              FileSaver.saveAs(content, blogTitle + ".zip");
            });
          }
        };
        image.src = item.image_url;
    })

  };

  const generateRandomCode = (length: number): string => {
    let code = "";
    for (let j = 0; j < length; j++) {
      code += Math.floor(Math.random() * 10); // 生成 0-9 之间的随机数
    }
    return code;
  };



  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="5xl"
      scrollBehavior={"inside"}
    >
      <ModalOverlay />
      <ModalContent
        // h="80vh"
        bg="#172248"
      >
        <ModalHeader color="#27314D" fontSize={"18px"}></ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody>
          <Box>
            <SimpleGrid columns={6} spacing={"20px"}>
              {images.map((item, index) => (
                <Box key={item.id}>
                  <SmrHistoryModalItem
                    content={item}
                    index={index}
                    onClose={onClose}
                    handleCheckBox={handleCheckBox}
                    onDelete={onDelete}
                  />
                </Box>
              ))}
            </SimpleGrid>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button
            w="76px"
            h="32px"
            mr="15px"
            color={"#FFFFFF"}
            fontSize="14px"
            fontWeight={"normal"}
            borderRadius={"38px"}
            background={"linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"}
            _hover={{
              background: "linear-gradient(90deg, #496AE1 0%, #66E8E0 100%)",
            }}
            onClick={OnDownload}
          >
            下载
          </Button>
          <Button
            w="76px"
            h="32px"
            color={"#FFFFFF"}
            fontSize="14px"
            fontWeight={"normal"}
            borderRadius={"38px"}
            background={"linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"}
            _hover={{
              background: "linear-gradient(90deg, #496AE1 0%, #66E8E0 100%)",
            }}
            onClick={handleBatchDelete}
          >
            删除
          </Button>
        </ModalFooter>
        
        <SmrDeleteModal
        isOpen={deleteControl.isOpen}
        onClose={deleteControl.onClose}
        onDelete={handleDeleteChecked}
      />
      </ModalContent>
    </Modal>
  );
};

export default SmrHistoryModal;
